const categorySlider = document.querySelectorAll('.category-slider');
categorySlider.forEach((el) => {
  const swiper = el.querySelector('.swiper');
  const next = el.querySelector('.swiper-button-next');
  const prev = el.querySelector('.swiper-button-prev');

  new Swiper(swiper, {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: next,
      prevEl: prev,
    },

    breakpoints: {
      1: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });
});

const topbar = new Swiper('#topbar-home', {
  slidesPerView: 1,
  spaceBetween: 20,
  autoplay: true,
  loop: true,
  delay: 5000,
});

const burgerIcon = document.querySelector('#burger-icon');
const menu = document.querySelector('#menu-menu-principal');
const header = document.querySelector('#header');

burgerIcon.addEventListener('click', () => {
  const isOpen = burgerIcon.getAttribute('aria-expanded') === 'true';
  const icon = burgerIcon.querySelector('i');

  if (isOpen) {
    burgerIcon.setAttribute('aria-expanded', 'false');
    header.classList.remove('header--fixed');
    icon.classList.remove('fa-times');
    icon.classList.add('fa-bars');
  } else {
    burgerIcon.setAttribute('aria-expanded', 'true');
    header.classList.add('header--fixed');
    icon.classList.remove('fa-bars');
    icon.classList.add('fa-times');
  }

  menu.classList.toggle('header__menu--open');
});
